/** Splits a positive millisecond delta into day/hour/minute/second parts. */
export function breakdownMs(diffMs) {
  const days = Math.floor(diffMs / 86400000);
  const hours = Math.floor((diffMs % 86400000) / 3600000);
  const mins = Math.floor((diffMs % 3600000) / 60000);
  const secs = Math.floor((diffMs % 60000) / 1000);
  return { days, hours, mins, secs };
}

/** Live countdown label, e.g. "9h 24m 15s". Past/absent targets read as terminal states. */
export function formatTimeUntil(targetDate, nowMs = Date.now()) {
  if (!targetDate) return "Completed";
  const target = targetDate instanceof Date ? targetDate : new Date(targetDate);
  if (Number.isNaN(target.getTime())) return "Completed";
  const diffMs = target.getTime() - nowMs;
  if (diffMs < 0) return "Running soon";
  const { days, hours, mins, secs } = breakdownMs(diffMs);
  if (days > 0) return `${days}d ${hours}h ${mins}m ${secs}s`;
  if (hours > 0) return `${hours}h ${mins}m ${secs}s`;
  if (mins > 0) return `${mins}m ${secs}s`;
  return `${secs}s`;
}
